import { SettingsService } from '../settings.service';
import { Component, Input, OnChanges, SimpleChanges ,OnInit} from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import moment from 'moment';
import { debounceTime,takeUntil } from 'rxjs/operators'; 
import { Subject } from 'rxjs';



@Component({
    selector: 'app-hmo-quota',
    templateUrl: './hmo-quota.component.html',
    styleUrls: ['./hmo-quota.component.scss'],
    standalone: false
})
export class HmoQuotaComponent implements OnInit {
  @Input() selectedUserId: number | null = null;
  private destroy$ = new Subject<void>();
  hmos: string[] = ['Clalit', 'Macabi', 'Meuhedet', 'Leumit'];
  months: string[] = [];
  forms: FormGroup[] = [];
  appointmentsCounts: { [hmo: string]: { [month: string]: number } } = {};
  constructor(private fb: FormBuilder, private SettingsService: SettingsService) { }

  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUserId) {
      this.resetFormsAndMonths();
      this.initializeMonths();
      this.initializeForms();
      this.fetchQuotaData();
    }
  }

  fetchAppointmentsCounts() {
    this.hmos.forEach((hmo, index) => {
      if (!this.appointmentsCounts[hmo]) {
        this.appointmentsCounts[hmo] = {};
      }
  
      this.months.forEach((month, monthIndex) => {
        const formValue = this.forms[index].get(month)?.value;
        if (this.isNumber(formValue)) {
          const formattedMonth = moment().startOf('month').add(monthIndex, 'months').format('YYYY-MM'); // Format as YYYY-MM
          this.SettingsService.getAppointmentsCount(hmo, formattedMonth).subscribe(count => {
            this.appointmentsCounts[hmo][month] = count['appointmentCount'];
          });
        } else {
          this.appointmentsCounts[hmo][month] = 0;
        }
      });
    });
  }


checkAndFetchAppointmentCount(hmo: string, month: string) {
  // If the count for the specific month and HMO doesn't exist, fetch it
  if (!this.appointmentsCounts[hmo]?.[month]) {
    const monthIndex = this.months.indexOf(month);
    const formattedMonth = moment().startOf('month').add(monthIndex, 'months').format('YYYY-MM');

    this.SettingsService.getAppointmentsCount(hmo, formattedMonth).subscribe(count => {
      if (!this.appointmentsCounts[hmo]) {
        this.appointmentsCounts[hmo] = {};
      }
      this.appointmentsCounts[hmo][month] = count['appointmentCount'];
    });
  }
}

  
  
   initializeMonths() {
    const startMonth = moment(); // Current month
    for (let i = 0; i < 12; i++) {
      this.months.push(startMonth.clone().add(i, 'months').format('MMMM')); // Add 12 months
    }
  }

  initializeForms() {
    this.hmos.forEach((hmo, hmoIndex) => {
      const formGroup = this.fb.group({});
      
      this.months.forEach((month) => {
        const control = new FormControl('');
        control.valueChanges.pipe(debounceTime(500),takeUntil(this.destroy$)).subscribe(value => {
          if (this.isNumber(value)) {
            this.checkAndFetchAppointmentCount(hmo, month);
          }
          this.saveHmoQuota(hmo, month, value);
          console.log(`Value: ${value}, Month: ${month}, HMO: ${hmo}`);
        });

        formGroup.addControl(month, control);
      });

      this.forms.push(formGroup);
    });
  }

  fetchQuotaData() {
    const quotaPromises = this.hmos.map(async (hmo, index) => {
      const data = await this.SettingsService.getHMOQuota(hmo);
      this.populateForm(index, data);
    });
  
    Promise.all(quotaPromises).then(() => {
      this.fetchAppointmentsCounts();
    });
  }

  populateForm(index: number, data: any) {
    if (!data || !data.length)  return;
    
    data=data[0]
    const months = this.months; 
    
    months.forEach((month) => {
      const value = data[month] !== undefined && data[month] !== null ? data[month] : '';
      this.forms[index].get(month)?.setValue(value,{emitEvent:false});
    });
  }
  saveHmoQuota(hmo: string, month: string, value: any) {
    const payload = {
      HMO: hmo,
      column: month,
      value: value
    };

    this.SettingsService.updateHMOQuota(payload).subscribe(
      response => {
        console.log('HMO quota updated successfully', response);
      },
      error => {
        console.error('Error updating HMO quota', error);
      }
    );
  }

  resetFormsAndMonths() {
    this.months = [];
    this.forms = [];
    this.appointmentsCounts={};
  }
  ngOnDestroy() {
    this.destroy$.next();   
    this.destroy$.complete(); 
  }

  isNumber(value: any): boolean {
  return !isNaN(value) && value !== null && value !== '';  
}
  


}
